import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const myClaimGroupsService = {
  all(params) {
    const queries = params ? '?' + params : '';
    return fetch(`/api/my/claim_groups${queries}`, request.get);
  }
};
export default myClaimGroupsService;